import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e23691a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-country-row" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = {
  key: 0,
  class: "search-country-selected"
}
const _hoisted_4 = ["data-iso", "onClick"]
const _hoisted_5 = { class: "search-country__options" }
const _hoisted_6 = ["onClick", "data-iso"]

import SearchIcon from "@/components/icons/SearchIcon.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import CheckIcon from "@/components/icons/CheckIcon.vue";
import { Country, useDataStore } from "@/stores/data";
import { computed, ComputedRef, ref, Ref, defineModel, PropType } from "vue";
import { detectMobile, getCountryImageSrc } from "@/helpers";
import CountryIcon from "@/components/icons/CountryIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchCountries',
  props: {
    "modelValue": {
  type: Array as PropType<Array<Country>>,
},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const dataStore = useDataStore();

const requestedCountries = _useModel(__props, "modelValue");
const isMobile: boolean = detectMobile();
const searchCountriesText: Ref<string> = ref("");
const searchFilteredCountries: ComputedRef<Country[]> = computed(() => {
  return searchCountriesText.value.trim().length
    ? [...dataStore.countries].filter(
        (c: Country) =>
          c.name
            .trim()
            .toLowerCase()
            .includes(searchCountriesText.value.trim().toLowerCase()) ||
          c.alias
            .split(",")
            .map((a) => a.trim().toLowerCase())
            .filter((a) =>
              a
                .toLowerCase()
                .trim()
                .includes(searchCountriesText.value.trim().toLowerCase())
            ).length
      )
    : dataStore.countries;
});

function searchInputClick(): void {
  searchCountriesText.value = "";
}

function countryClick(country: Country): void {
  const countryExist: number | undefined = requestedCountries.value?.findIndex(
    (c: Country) => c.iso === country.iso
  );

  if (countryExist >= 0) {
    requestedCountries.value?.splice(countryExist, 1);
  } else {
    requestedCountries.value?.push(country);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchCountriesText).value = $event)),
          type: "text",
          class: "form-control active",
          placeholder: "Search a country",
          onFocus: searchInputClick
        }, null, 544), [
          [_vModelText, searchCountriesText.value]
        ]),
        _createVNode(SearchIcon, { class: "input-suffix" })
      ]),
      (!_unref(isMobile) || requestedCountries.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requestedCountries.value, (country) => {
              return (_openBlock(), _createElementBlock("button", {
                key: country.id,
                class: "search-country-selected__button",
                "data-iso": country.iso,
                onClick: () => countryClick(country)
              }, [
                _createTextVNode(_toDisplayString(country.name) + " ", 1),
                _createVNode(CloseIcon, { class: "search-country-selected__button--suffix" })
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchFilteredCountries.value, (country) => {
        return (_openBlock(), _createElementBlock("button", {
          key: country.id,
          class: _normalizeClass(["search-country__button", { active: requestedCountries.value?.includes(country) }]),
          onClick: () => countryClick(country),
          "data-iso": country.iso
        }, [
          _createVNode(CountryIcon, {
            class: "search-country__button--icon",
            country: country
          }, null, 8, ["country"]),
          _createElementVNode("span", null, _toDisplayString(country.name), 1),
          (requestedCountries.value?.includes(country))
            ? (_openBlock(), _createBlock(CheckIcon, {
                key: 0,
                class: "search-country__button--suffix"
              }))
            : _createCommentVNode("", true)
        ], 10, _hoisted_6))
      }), 128))
    ])
  ]))
}
}

})